export const state = {
  steps: [
    {
      id: 1,
      label: "General Information",
      component: "job-application-general-form",
      routeAlias: "/general"
    },
    {
      id: 2,
      label: "Education",
      component: "job-application-education-form",
      routeAlias: "/education"
    },
    {
      id: 3,
      label: "Employment Experience",
      component: "job-application-employment-form",
      routeAlias: "/employment"
    },
    {
      id: 4,
      label: "Additional Information",
      component: "job-application-additional-form",
      routeAlias: "/additional"
    },
    {
      id: 5,
      label: "Applicant's Statement",
      component: "job-application-statement-form",
      routeAlias: "/statement"
    },
    {
      id: 6,
      label: "Review & Submit",
      component: "job-application-review-form",
      routeAlias: "/review"
    }
  ]
};

export const getters = {
  // currentView: state => {
  //   return state.currentView;
  // },
};
